<template lang="pug">

    .ui.labels
        router-link.ui.label(:to='{ name: "users", query: allQuery }' exact)
            | Alle:
            .ui.detail {{ counts.all }}
        router-link.ui.label(:to='{ name: "users", query: hasAccessQuery }' exact)
            | Aktiv:
            .ui.detail {{ counts.hasAccess }}
        router-link.ui.label(:to='{ name: "users", query: hasNoAccessQuery }' exact)
            | Inaktiv:
            .ui.detail {{ counts.hasNoAccess }}

</template>

<script>
    import isNumber from 'lodash/fp/isNumber'
    import { to_number } from '@/utils/number'

    function apply_query(query, ctx) {
        // ggf. Unternehmen hinzufuegen
        if (isNumber(ctx.companyId)) {
            query.company = ctx.companyId
        }

        return query
    }

    // noinspection JSUnusedGlobalSymbols
    export default {

        computed: {

            allQuery() {
                return apply_query({}, this)
            },

            companyId() {
                return to_number(this.$route.query.company)
            },

            hasAccessQuery() {
                return apply_query({ status: 'HAS_ACCESS' }, this)
            },

            hasNoAccessQuery() {
                return apply_query({ status: 'HAS_NO_ACCESS' }, this)
            }

        },

        props: {

            counts: {
                type: Object,
                required: true
            }

        },

    }

</script>
